import { render, staticRenderFns } from "./GSGnGEMAContentCN.vue?vue&type=template&id=70a503b5&scoped=true"
import script from "./GSGnGEMAContentCN.vue?vue&type=script&lang=js"
export * from "./GSGnGEMAContentCN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a503b5",
  null
  
)

export default component.exports